import { notification } from '@pu/mpp-ui/notifications';
import type { TCreateMaintenanceParams } from 'core/model/interfaces/maintenance';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage, showNotificationError } from 'shared/utils/errors.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IMaintenanceState } from '../types';

export const createMaintenance = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/createMaintenance`,
  async (params: { data: TCreateMaintenanceParams }) => {
    try {
      const { data } = params;

      await apiService.maintenance.createMaintenance(data);

      notification.success('Se creó una pantalla de mantenimiento correctamente.');
    } catch (error) {
      const errorMessage = handleErrorMessage(
        error,
        'No se pudo crear la pantalla. Verifica que todos los campos estén completos.',
      );

      showNotificationError(errorMessage);

      throw error;
    }
  },
);

export const createMaintenanceReducer: TSliceExtraReducer<IMaintenanceState> = builder =>
  builder
    .addCase(createMaintenance.pending, state => {
      state.form.loading = true;
      state.form.success = false;
    })
    .addCase(createMaintenance.rejected, state => {
      state.form.loading = false;
      state.form.success = false;
    })
    .addCase(createMaintenance.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
    });
